import { Injectable, OnDestroy, TemplateRef, Type, signal } from '@angular/core';
import { EmptyButtonsComponent } from 'app/layout/components/buttonbar/empty/empty-buttons.component';
import { BehaviorSubject, Subject } from 'rxjs';

import { equalPrimitives } from 'app/main/shared/utils';
import { ViewState } from '../shared/viewstate';

export interface IButtonContent {
    data?: any;
    empty?: boolean;
    component?: Type<any>;
    parent?: any;
}

@Injectable({
    providedIn: 'root',
})
export class ButtonsBarService implements OnDestroy {
    private _buttons = new BehaviorSubject<IButtonContent>({ empty: true });
    private readonly _state = signal(ViewState.NEW);
    private _cmp: Type<any>;
    private _contentMobile = new Subject<TemplateRef<any>>();
    public buttonsContent = signal<IButtonContent>({ empty: true }, { equal: equalPrimitives });

    constructor() {
        console.log('ButtonsBarService created');
    }

    // Add Normal buttons group to button bar
    addContent(c: Type<any>, data?: any, parent?: any): void {
        console.log('BUTTONBAR_ADD', c);
        this._cmp = c;
        this.buttonsContent.set({ data, empty: false, component: c, parent: parent });
        this._buttons.next(this.buttonsContent());
    }

    addMobile(mobilButtons: TemplateRef<any>): void {
        this._contentMobile.next(mobilButtons);
    }

    clear(): void {
        //debugger;
        console.log('BUTTONBAR_ADD: CLEAR');
        if (this._cmp && !this.buttonsContent().empty) {
            this._cmp = EmptyButtonsComponent;
            this.buttonsContent.set({ empty: true, component: this._cmp });
            this._buttons.next(this.buttonsContent());
        }
    }

    get mobile() {
        return this._contentMobile;
    }

    get buttons() {
        return this._buttons;
    }

    // ViewState
    changeViewState(state: ViewState): void {
        this._state.set(state);
    }

    get viewState() {
        return this._state();
    }

    ngOnDestroy() {
        this._contentMobile.unsubscribe();
        this._buttons.unsubscribe();
    }
}
